<template>
  <div>
    <b-card no-body class="card-transparent-background">
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Accounts Registeration
        </b-card-title>
        <b-card-sub-title class="card-subtitle-form-steps-garden-help">
          Please provide us with your details to start working now
        </b-card-sub-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card no-body>
          <b-card-body class="px-2 py-4">
            <div class="container">
              <b-row>
                <b-col>
                  <b-form-group
                    class="
                      form-group-radio-group form-group-radio-garden-help
                    "
                    label="Do you want to add another administrator"
                    v-slot="{ ariaDescribedby }"
                    label-class="form-label-garden-help text-left mb-2"
                    :add_admin="add_admin"
                  >
                    <b-form-radio-group
                      id="add_admin"
                      v-model="_add_admin"
                      :aria-describedby="ariaDescribedby"
                      name="add_admin"
                      stacked
                    >
                      <b-form-radio
                        class="
                          form-control form-control-garden-help
                          radio-input-container
                          mb-1
                        "
                        v-model="add_admin"
                        :aria-describedby="ariaDescribedby"
                        name="add_admin"
                        value="1"
                        >Yes</b-form-radio
                      >
                      <b-form-radio
                        class="
                          form-control form-control-garden-help
                          radio-input-container
                          mb-1
                        "
                        v-model="_add_admin"
                        :aria-describedby="ariaDescribedby"
                        name="add_admin"
                        value="0"
                        >No</b-form-radio
                      >
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </b-card-body>
    </b-card>
    <b-card
      no-body
      class="card-transparent-background my-0"
      v-if="_add_admin == 1"
    >
      <b-card-header class="p-0">
        <b-card-title class="card-title-form-steps-garden-help">
          Admins Details
        </b-card-title>
      </b-card-header>
      <b-card-body class="p-0">
        <b-card
          no-body
          class="py-2 px-3"
          v-for="(admin, index) in admins"
          :key="index"
        >
          <b-card-header class="px-0">
            <b-row>
              <b-col cols="10">
                <b-card-title class="card-title-garden-help-default">
                  Admin {{ index + 1 }}
                </b-card-title>
              </b-col>
              <b-col cols="2">
                <b-button
                  type="button"
                  variant="action-garden-help"
                  v-if="index != 0"
                  @click="clickDeleteAdmin(index)"
                >
                  <img src="@/assets/images/garden-help/delete-icon.png" />
                </b-button>
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body class="py-2 px-1">
            <div class="container p-0">
              <b-row>
                <b-col sm="12">
                  <b-form-group
                    class="form-group-garden-help"
                    label="Name* "
                    label-for="name"
                    label-class="form-label-garden-help"
                  >
                    <p
                      class="error_validation_message_p_gardenhelp"
                      v-if="admin.invalid_name"
                    >
                      Please enter name
                    </p>
                    <b-form-input
                      v-if="type == 'register' || type == 'edit'"
                      class="form-control-garden-help"
                      :id="'name' + (index + 1)"
                      :name="'name' + (index + 1)"
                      v-model="admin.name"
                      required
                    ></b-form-input>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-garden-help"
                    >
                      {{ admin.name }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group
                    class="form-group-garden-help"
                    label="Email Address* "
                    label-for="email"
                    label-class="form-label-garden-help"
                  >
                    <p
                      class="error_validation_message_p_gardenhelp"
                      v-if="admin.invalid_email"
                    >
                      Please enter email
                    </p>
                    <b-form-input
                      v-if="type == 'register' || type == 'edit'"
                      class="form-control-garden-help"
                      :id="'email' + (index + 1)"
                      :name="'email' + (index + 1)"
                      type="email" @keydown.space.prevent
                      v-model="admin.email"
                      required
                    ></b-form-input>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-garden-help"
                    >
                      {{ admin.email }}
                    </span>
                  </b-form-group>
                </b-col>
                <b-col sm="12">
                  <b-form-group
                    class="mobile-number-input-group-garden-help"
                    label="Phone Number*"
                    label-for="phone_number"
                    label-class="form-label-garden-help"
                  >
                    <p
                      class="error_validation_message_p_gardenhelp"
                      v-if="admin.invalid_phone_number"
                    >
                      Please enter phone number
                    </p>
                    <vue-tel-input
                      v-if="type == 'register' || type == 'edit'"
                      class="form-control form-control-garden-help"
                      :id="'phone_number' + (index + 1)"
                      v-model="admin.phone_number"
                      required
                    ></vue-tel-input>
                    <span
                      v-if="type == 'profile'"
                      class="form-control form-control-garden-help"
                    >
                      {{ admin.phone_number }}
                    </span>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
        <b-button
          variant="garden-help-primary-link"
          class="btn-bumblebee btn-garden-help"
          @click="clickAddAdmin"
        >
          <span class="btn-icon"
            ><font-awesome-icon icon="fa-solid fa-circle-plus" />
          </span>
          Add another adminstrator
        </b-button>
      </b-card-body>
    </b-card>
  </div>
</template>
        
<script>
export default {
  name: "AdminsRegistrations",
  components: {},
  props: ["type", "is_company", "add_admin", "admins"],

  data() {
    return {};
  },
  mounted() {},

  computed: {
    _add_admin: {
      get() {
        return this.add_admin;
      },
      set(value) {
        this.$emit("update:add_admin", value);
        if (value == 0) {
          this.admins = [
            {
              name: "",
              invalid_name: false,
              email: "",
              invalid_email: false,
              phone_number: "",
              invalid_phone_number: false,
            },
          ];
        }
      },
    },
  },
  methods: {
    clickAddAdmin() {
      this.admins.push({
        name: "",
        invalid_name: false,
        email: "",
        invalid_email: false,
        phone_number: "",
        invalid_phone_number: false,
      });
    },
    clickDeleteAdmin(index) {
      this.admins.splice(index, 1);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/projects/garden_help/contractor/profile_details_components/AdminsRegistrations.vue